export enum ErrorWarningTypes {
  Error = 'error',
  Warning = 'warning',
  None = 'none',
}
